import { Modal, ModalOverlay, useToast } from '@apexinternal/ui-components'
import { Box, Icon, Link, useDisclosure } from '@chakra-ui/react'
import React, { useState } from 'react'
import { FaRegEdit } from 'react-icons/fa'
import { closeAccount } from '../../../../actions'
import { PermissionsEnum } from '../../../../constants'
import { usePermissions, useToastErrorHandler } from '../../../../hooks'
import { AccountDetails } from '../../../../types'
import ConfirmModalContent from './ConfirmModalContent'
import EditModalContent from './EditModalContent'

interface CloseAccountModalProps {
  accountDetails: AccountDetails
}

export const SUCCESS_DESCRIPTION =
  'Your request has been successfully submitted, please allow up to 24 hours for this change to take effect. If you need to re-open an account, please contact your Apex representative.'

const CloseAccountModal = ({ accountDetails }: CloseAccountModalProps) => {
  const { hasPermission } = usePermissions()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isReplacedByFdid, setReplacedByFdid] = useState(false)
  const [fdid, setFdid] = useState('')
  const [isConfirmationView, setConfirmationView] = useState(false)
  const onError = useToastErrorHandler()
  const toast = useToast()

  const reset = () => {
    setReplacedByFdid(false)
    setFdid('')
    setConfirmationView(false)
  }

  const closeModal = () => {
    reset()
    onClose()
  }

  const confirmCloseAccount = () => {
    closeAccount(
      onError,
      () => {
        toast({
          title: 'Success!',
          description: SUCCESS_DESCRIPTION,
          status: 'success',
          isClosable: true,
        })
        closeModal()
      },
      accountDetails.accountNumber,
      fdid.trim()
    )
  }

  const canCloseAccount = hasPermission(PermissionsEnum.AccountRestrictClose)
  return canCloseAccount ? (
    <Box>
      <Link color="blue.500" onClick={onOpen}>
        <Icon as={FaRegEdit} marginRight="0.357rem" />
        Close Account
      </Link>
      <Modal isCentered isOpen={isOpen} onClose={() => {}} size="lg">
        <ModalOverlay />
        {isConfirmationView ? (
          <ConfirmModalContent
            accountDetails={accountDetails}
            isReplacedByFdid={isReplacedByFdid}
            fdid={fdid}
            onClose={closeModal}
            onConfirm={confirmCloseAccount}
            onBack={() => setConfirmationView(false)}
          />
        ) : (
          <EditModalContent
            accountDetails={accountDetails}
            isReplacedByFdid={isReplacedByFdid}
            fdid={fdid}
            setReplacedByFdid={setReplacedByFdid}
            setFdid={setFdid}
            onClose={closeModal}
            onConfirm={() => setConfirmationView(true)}
          />
        )}
      </Modal>
    </Box>
  ) : null
}

export default CloseAccountModal
